import PropTypes from 'prop-types';
import React from 'react';
import MenuIcon from 'components/MenuIcon/MenuIcon';
import {useIntl} from 'react-intl';
import {HeaderLayout, SearchBar} from '../../components';
import {DrawerButtonTitle} from '../Common';

function UserManagementHeader(props) {
  const intl = useIntl();

  const {
    searchUserValue,
    sortIsDesc,
    removeDisabled,
    editDisabled,
    newUserClick,
    searchUserOnChange,
    sortByClick,
    removeClick,
    editClick,
  } = props;

  const iconSort = sortIsDesc ? 'SortDescendingAlpha' : 'SortAscendingAlpha';

  const labelNewUser = intl.formatMessage({id: 'userManagement.header.newUser'});
  const labelSortBy = intl.formatMessage({id: 'userManagement.header.sortBy'});
  const labelRemoveUser = intl.formatMessage({id: 'userManagement.header.removeUser'});
  const labelEditUser = intl.formatMessage({id: 'userManagement.header.editUser'});

  const placeholderSearch = intl.formatMessage({id: 'userManagement.header.searchUserPlaceholder'});

  return (
    <HeaderLayout>
      <HeaderLayout.Left>
        <DrawerButtonTitle title="User Management" />
      </HeaderLayout.Left>
      <HeaderLayout.Center>
        <MenuIcon icon="FloAddUser" label={labelNewUser} onClick={newUserClick} />
        <SearchBar placeholder={placeholderSearch} value={searchUserValue} onChange={searchUserOnChange} />
        <MenuIcon icon={iconSort} label={labelSortBy} onClick={sortByClick} />
        <MenuIcon icon="Trash" label={labelRemoveUser} disabled={removeDisabled} onClick={removeClick} />
        <MenuIcon icon="Pencil" label={labelEditUser} disabled={editDisabled} onClick={editClick} />
      </HeaderLayout.Center>
      <HeaderLayout.Right />
    </HeaderLayout>
  );
}

UserManagementHeader.propTypes = {
  searchUserValue: PropTypes.string,
  sortIsDesc: PropTypes.bool,
  removeDisabled: PropTypes.bool,
  editDisabled: PropTypes.bool,
  newUserClick: PropTypes.func,
  searchUserOnChange: PropTypes.func,
  sortByClick: PropTypes.func,
  removeClick: PropTypes.func,
  editClick: PropTypes.func,
};

UserManagementHeader.defaultProps = {
  searchUserValue: '',
  sortIsDesc: false,
  removeDisabled: false,
  editDisabled: false,
  newUserClick: () => {},
  searchUserOnChange: () => {},
  sortByClick: () => {},
  removeClick: () => {},
  editClick: () => {},
};

export default UserManagementHeader;
